import React from 'react';
import Button from '@material-ui/core/Button';
import TextField from '@material-ui/core/TextField';
import Dialog from '@material-ui/core/Dialog';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import DialogContentText from '@material-ui/core/DialogContentText';
import { DialogTitle, FormControlLabel, Switch } from '@material-ui/core';
import { InputBase, Typography} from '@material-ui/core';
export default function CodingDialog(props) {
    const [open, setOpen] = React.useState(props.open);
    const [link, setLink] = React.useState({ stepSize: "", });

    const handleChange = (event) => {
        setLink({ ...link, [event.target.name]: event.target.checked });
    };
    const handleSave = () => {
        setOpen(false);
        var ff = { ...link }
        ff.stepSize = parseInt(ff.stepSize)
       
        if (props.cb) props.cb(ff)
    };
    React.useEffect(() => {
    }, [])
    React.useEffect(() => {
        setOpen(props.open)
        if (props.linkstate) {
            const ls = props.linkstate
            var ff = ls.stepSize
            setLink({ stepSize: ff})
        }
    }, [props])
    const handleClose = () => {
        setOpen(false);
        if (props.cb) props.cb(null)
    };
    function pasteText(e) {
        e.preventDefault()
        const txt = e.clipboardData.getData('text/plain')
        setLink({
            ...link,
            [e.target.id]: txt
        })
    }

    function handleType(e) {
        setLink({
            ...link,
            [e.target.id]: e.target.value
        })
    }

    // function handleSubmit(e) {
    //     console.log("HIT SUBMIT")
    //     e.preventDefault()
    //     if (link.name.length >= 0 && link.link.length >= 0) handleSave()
    // }
    return (
        <Dialog open={open} onClose={handleClose} aria-labelledby="form-dialog-title">
            <DialogTitle id="form-dialog-title">Coding Parameters</DialogTitle>
            <DialogContent>
                <DialogContentText style= {{marginBottom: "0px"}}>

                    <InputBase
                        autoFocus
                        margin="dense"
                        id="stepSize"
                        name="stepSize"
                        placeholder="Step Size"
                        fullWidth
                        value={link.stepSize}
                        onChange={(e) => handleType(e)}
                        className="inputTextFiled"
                    />
                    {props.children && (
                        <TextField
                            margin="dense"
                            id="answer"
                            name="answer"
                            label="Answer"
                            fullWidth
                            multiline
                            helperText="Separate options with ; like: $25; 25"
                            value={link.answer}
                            onPaste={pasteText}
                            onChange={(e) => handleType(e)}
                        />
                    )}

                </DialogContentText>
                {/* <FormControlLabel
                    control={<Switch checked={link.ignoreSpecial} onChange={handleChange} name="ignoreSpecial" />}
                    label="Ignore special characters ($, %...)"
                /> */}
            </DialogContent>
            <DialogActions style={{padding:"0px"}}>
                <div className="positioning">
                    <Typography
                        variant="contained"
                        size="small"
                        style={{ marginRight: "24px", fontSize: "16px", }}
                        onClick={handleClose}
                        className='formCancel'
                    >
                        Cancel
                        </Typography>
                    <Button onClick={handleSave} color="primary" style={{ backgroundColor: props.inkColor }} className="createButton">
                        Save
                   </Button>
                </div>
            </DialogActions>

        </Dialog>
    );
}
